export default "__VITE_ASSET__2nEqWwkp__"